import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.redirect || "/dashboard";
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(form.email, form.password);
    if (res.ok) {
      toast.success("Welcome back.");
      navigate(redirect);
    } else {
      setError(res.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[calc(100vh-320px)] flex items-center py-16" data-testid="login-page">
      <div className="max-w-md mx-auto w-full px-6">
        <div className="text-center">
          <div className="overline">Member sign in</div>
          <h1 className="mt-4 font-heading text-4xl">Welcome back</h1>
          <p className="mt-3 text-[color:var(--azsam-ink-soft)]">Access your member portal, register for events, and browse the clinician directory.</p>
        </div>
        <form onSubmit={handleSubmit} className="mt-10 azsam-card p-8 space-y-5" data-testid="login-form">
          <label className="block">
            <div className="text-xs uppercase tracking-widest text-[color:var(--azsam-ink-soft)] mb-2 font-semibold">Email</div>
            <input
              type="email" required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full px-4 py-3 rounded-lg border border-[color:var(--azsam-stone)] focus:outline-none focus:border-[color:var(--azsam-clay)]"
              data-testid="login-email"
            />
          </label>
          <label className="block">
            <div className="text-xs uppercase tracking-widest text-[color:var(--azsam-ink-soft)] mb-2 font-semibold">Password</div>
            <input
              type="password" required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full px-4 py-3 rounded-lg border border-[color:var(--azsam-stone)] focus:outline-none focus:border-[color:var(--azsam-clay)]"
              data-testid="login-password"
            />
          </label>
          {error && <div className="text-sm text-[color:var(--azsam-mesa)] bg-[color:var(--azsam-mesa)]/8 p-3 rounded-md" data-testid="login-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-sm text-center text-[color:var(--azsam-ink-soft)]">
            New here? <Link to="/register" className="text-[color:var(--azsam-clay)] font-medium hover:underline" data-testid="login-to-register">Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
